import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Button } from "@mui/material";
import PropTypes from "prop-types";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  arrowLeft: {
    transform: "rotate(180deg)",
    margin: theme.spacing(0, 1, 0, 0)
  },
  arrow: {
    marginLeft: theme.spacing(1)
  },
  disabled: {
    "&$disabled": {
      color: theme.palette.action.disabled
    }
  }
}));

const PreviousAndNextButtons = ({
  hasNextPage,
  hasPrevPage,
  onNextClick,
  onPrevClick
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <Button
        color="primary"
        disabled={!hasPrevPage}
        className={clsx({
          [classes.disabled]: !hasPrevPage
        })}
        onClick={onPrevClick}
      >
        <ArrowRightAltIcon
          classes={{ root: `${classes.arrow} ${classes.arrowLeft}` }}
          color={!hasPrevPage ? "action" : "primary"}
        />
        {t("pagination.prevBtn")}
      </Button>
      <Button
        color="primary"
        disabled={!hasNextPage}
        className={clsx({
          [classes.disabled]: !hasNextPage
        })}
        onClick={onNextClick}
      >
        {t("pagination.nextBtn")}
        <ArrowRightAltIcon
          classes={{ root: classes.arrow }}
          color={!hasNextPage ? "action" : "primary"}
        />
      </Button>
    </>
  );
};

export default PreviousAndNextButtons;

PreviousAndNextButtons.propTypes = {
  /**
   * If false, the next page button is disabled
   */
  hasNextPage: PropTypes.bool,
  /**
   * If false, the previous page button is disabled
   */
  hasPrevPage: PropTypes.bool,
  /**
   * function that is called when Next button is clicked
   */
  onNextClick: PropTypes.func,
  /**
   * function that is called when Previous button is clicked
   */
  onPrevClick: PropTypes.func
};
